// Notifications Module
// Handles notification system

export class NotificationManager {
    constructor() {
        this.notifications = [];
        this.container = null;
        this.init();
    }

    // Initialize notification system
    init() {
        this.createContainer();
    }

    // Create notification container
    createContainer() {
        this.container = document.querySelector('.notifications-container');
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'notifications-container';
            this.container.style.cssText = `
                position: fixed;
                top: 20px;
                right: 20px;
                z-index: 9999;
                max-width: 400px;
            `;
            document.body.appendChild(this.container);
        }
    }

    // Show notification
    show(message, type = 'info', duration = 5000) {
        const notification = this.createNotification(message, type);
        this.container.appendChild(notification);
        this.notifications.push(notification);

        // Auto-dismiss after duration
        if (duration > 0) {
            setTimeout(() => {
                this.dismiss(notification);
            }, duration);
        }

        return notification;
    }

    // Create notification element
    createNotification(message, type) {
        const notification = document.createElement('div');
        notification.className = `alert alert-${type} alert-dismissible fade show`;
        notification.style.cssText = `
            margin-bottom: 10px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        `;
        
        notification.innerHTML = `
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        `;

        // Add click handler for close button
        const closeBtn = notification.querySelector('.btn-close');
        closeBtn.addEventListener('click', () => {
            this.dismiss(notification);
        });

        return notification;
    }

    // Dismiss notification
    dismiss(notification) {
        if (notification && notification.parentNode) {
            notification.classList.remove('show');
            setTimeout(() => {
                if (notification.parentNode) {
                    notification.remove();
                }
                // Remove from notifications array
                const index = this.notifications.indexOf(notification);
                if (index > -1) {
                    this.notifications.splice(index, 1);
                }
            }, 150); // Match Bootstrap's fade transition duration
        }
    }

    // Clear all notifications
    clear() {
        this.notifications.forEach(notification => {
            this.dismiss(notification);
        });
    }

    // Show success notification
    success(message, duration = 5000) {
        return this.show(message, 'success', duration);
    }

    // Show error notification
    error(message, duration = 7000) {
        return this.show(message, 'danger', duration);
    }

    // Show warning notification
    warning(message, duration = 6000) {
        return this.show(message, 'warning', duration);
    }

    // Show info notification
    info(message, duration = 5000) {
        return this.show(message, 'info', duration);
    }
}

// Export singleton instance
export const notificationManager = new NotificationManager();

